if (document.querySelector('.js-sub-categories')) {
  const subCategories = document.querySelector('.js-sub-categories')
  const menuList = subCategories.querySelectorAll('.blog-category--item')
  menuList.forEach(item => {
    itemLink = item.querySelector('a')
    itemHref = itemLink.getAttribute('href')
    if (window.location.pathname === itemHref) {
      item.classList.add('active');
      itemLink.classList.add('active')
    } else if (itemLink.classList.contains('active')) {
      item.classList.remove('active');
      itemLink.classList.remove('active')
    }
  })
}

if (document.querySelector('.featured-article')) {
  const featuredArticles = document.querySelectorAll('.featured-article')
  featuredArticles[0].classList.add('is-active');
}